import 'css-chunksrc/client/scenes/projectPortfolioEdition/form/projectSelection/styles.scss';export default {
  "input": "_input_14duq_1",
  "opened": "_opened_14duq_13",
  "toggleArrow": "_toggleArrow_14duq_17",
  "name": "_name_14duq_21",
  "placeholder": "_placeholder_14duq_29",
  "selectedProjects": "_selectedProjects_14duq_34",
  "selectedProject": "_selectedProject_14duq_34",
  "listRoot": "_listRoot_14duq_59",
  "list": "_list_14duq_59",
  "item": "_item_14duq_77",
  "project": "_project_14duq_88",
  "selected": "_selected_14duq_34",
  "folderIcon": "_folderIcon_14duq_97"
};